<template>
   <div class="flight-sales-report-container sub-page-wrapper">
      <Aside />
      <Main>
         <Navbar />
         <div class="container-fluid">
            <div class="row">
               <div class="col gts-box mx-3">
                  <h1 class="sub-page-header">{{ $t("flightSalesReport_title") }}</h1>
                  <div class="sub-page-row-wrapper row gy-3">
                     <div class="col-12 col-md-6 col-lg-2 reportType">
                        <UISelectBox :key="$i18n.locale" :label="$t('flightSalesReport_reportType')" id="report-type" :options="dateTypeOptions" v-model="searchQuery.dateType" lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 fromDate">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('flightSalesReport_creationFromDate')"
                           v-model="searchQuery.date1.value"
                           :min="searchQuery.date1.min"
                           :max="searchQuery.date1.max"
                           lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 toDate">
                        <UIDatePicker
                           :key="$i18n.locale"
                           :label="$t('flightSalesReport_creationToDate')"
                           v-model="searchQuery.date2.value"
                           :min="searchQuery.date2.min"
                           :max="searchQuery.date2.max"
                           lighter />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 pnrStatus">
                        <UIMultiSelect :key="$i18n.locale" :label="$t('flightSalesReport_pnrStatus')" id="pnr-status" :options="pnrStatusList" v-model="searchQuery.pnrStatuses" lighter allow-search />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 airlineList">
                        <UIMultiSelect
                           :key="$i18n.locale"
                           :label="$t('flightSalesReport_airlineList')"
                           id="airline-list"
                           :options="airlineList"
                           v-model="searchQuery.airlineIds"
                           lighter
                           allSelected
                           allow-search />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 providerList">
                        <UIMultiSelect
                           :key="$i18n.locale"
                           :label="$t('flightSalesReport_providerList')"
                           id="provider-list"
                           :options="providerList"
                           v-model="searchQuery.providerIds"
                           lighter
                           allSelected
                           allow-search />
                     </div>
                     <div class="col-12 col-md-6 col-lg-2 userList">
                        <UIMultiSelect
                           :key="$i18n.locale"
                           :label="$t('flightSalesReport_userList')"
                           id="user-list"
                           :options="userList"
                           v-model="searchQuery.userIds"
                           lighter
                           allSelected
                           allow-search />
                     </div>
                  </div>
                  <div class="sub-page-actions-row row">
                     <div class="sub-pages-actions-wrapper col-12">
                        <div class="toggle-container">
                           <div class="toggle-wrapper">
                              <label>{{ $t("flightSalesReport_showReissues") }}</label>
                              <b-switch v-model="searchQuery.showReissues"></b-switch>
                           </div>
                        </div>
                        <UIButton className="default" :text="$t('common_list')" @click.native="listFlightSalesReport" />
                     </div>
                  </div>
               </div>
            </div>
            <template v-if="currentTableOptions.rows.length > 0">
               <ReportSummary entityType="flight" :summary="summary" />
               <div class="smart-table-wrapper">
                  <SmartTable :options="currentTableOptions" @table-mode="handleMode" />
               </div>
            </template>
         </div>
      </Main>
   </div>
</template>

<script>
import moment from "moment";
import Popup from "@/gts-popup.js";
import Main from "@/components/unitary/Main.vue";
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import UIButton from "@/components/unitary/Button.vue";
import UISelectBox from "@/components/unitary/form2/UISelectBox.vue";
import ReportSummary from "@/components/unitary/SalesReportSummary.vue";
import UIDatePicker from "@/components/unitary/form2/UIDatePicker2.vue";
import UIMultiSelect from "@/components/unitary/form2/UIMultiSelect.vue";
import { userService, reportService, agencyService, globalService } from "@/service/index.js";

export default {
   name: "FlightSalesReport",
   components: {
      Main,
      Aside,
      Navbar,
      UIButton,
      UISelectBox,
      UIDatePicker,
      ReportSummary,
      UIMultiSelect,
   },
   data() {
      return {
         searchQuery: {
            dateType: 1,
            date1: {
               min: moment("2022-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            date2: {
               min: moment("2022-01-01").format(this.$constants.dateFormat),
               max: moment().format(this.$constants.dateFormat),
               value: moment().format(this.$constants.dateFormat),
            },
            pnrStatuses: [2, 3],
            providerIds: [],
            userIds: [],
            airlineIds: [],
            showReissues: true,
            inpSwithPnrEticket: false,
         },
         tableOptions: {
            columns: [],
            rows: [],
            rules: {
               autoMerge: ["orderId", "pnr", "pnrStatus"],
               dominantCell: "orderId",
               showOnMobile: [0, 1, 2, 6, 7],
               highlightedColumns: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
            },
            options: {
               header: {
                  title: this.$options.name,
                  viewOptions: {
                     status: true,
                     perPage: 50,
                     selects: [
                        { name: `3 ${this.$t("common_order")}`, value: 3 },
                        { name: `5 ${this.$t("common_order")}`, value: 5 },
                        { name: `25 ${this.$t("common_order")}`, value: 25 },
                        { name: `50 ${this.$t("common_order")}`, value: 50 },
                        { name: `100 ${this.$t("common_order")}`, value: 100 },
                        { name: `${this.$t("common_all")}`, value: null },
                     ],
                  },
                  viewMode: "default",
                  saleDateIndex: 10,
                  viewModes: [
                     { name: "E-Ticket", value: "alternative" },
                     { name: "Pnr", value: "default" },
                  ],
               },
               footer: {
                  pagination: {
                     pages: [],
                     activepage: 1,
                  },
               },
            },
         },
         alternativeTableOptions: {
            columns: [],
            rows: [],
            rules: {
               autoMerge: ["orderId", "pnr", "pnrStatus"],
               dominantCell: "orderId",
               showOnMobile: [0, 1, 2, 5, 6, 7],
               highlightedColumns: [7, 8, 9, 10, 11, 12, 13, 14, 15],
            },
            options: {
               header: {
                  title: this.$options.name,
                  viewOptions: {
                     status: true,
                     perPage: 50,
                     selects: [
                        { name: `3 ${this.$t("common_order")}`, value: 3 },
                        { name: `5 ${this.$t("common_order")}`, value: 5 },
                        { name: `25 ${this.$t("common_order")}`, value: 25 },
                        { name: `50 ${this.$t("common_order")}`, value: 50 },
                        { name: `100 ${this.$t("common_order")}`, value: 100 },
                        { name: `${this.$t("common_all")}`, value: null },
                     ],
                  },
                  viewMode: "alternative",
                  saleDateIndex: 11,
                  viewModes: [
                     { name: "E-Ticket", value: "alternative" },
                     { name: "Pnr", value: "default" },
                  ],
               },
               footer: {
                  pagination: {
                     pages: [],
                     activepage: 1,
                  },
               },
            },
         },
         summary: null,
         tableMode: "default",
         initialProvidersList: [],
         initialUserList: [],
         initialAirlineList: [],
      };
   },
   created() {
      agencyService.listProviders({ type: 1 }).then((res) => {
         this.initialProvidersList = res.providers;
         this.searchQuery.providerIds = res.providers.map((provider) => provider.id);
      });
      globalService.getAirlineList().then((res) => {
         this.initialAirlineList = res;
         this.searchQuery.airlineIds = res.map((airline) => airline.iataCode);
      });
      userService.listUsers({}).then((res) => {
         this.initialUserList = res.users;
         this.searchQuery.userIds = res.users.map((user) => user.id);
      });
   },
   computed: {
      providerList() {
         return this.initialProvidersList.map((provider) => ({
            value: provider.id,
            name: provider.name,
         }));
      },
      airlineList() {
         return this.initialAirlineList.map((airline) => ({
            value: airline.iataCode,
            name: `${airline.iataLabel} - ${airline.nameTr}`,
         }));
      },
      userList() {
         return this.initialUserList.map((user) => ({
            value: user.id,
            name: `${user.name}<br/><span class="txt-small">${user.email}</span>`,
         }));
      },
      pnrStatusList() {
         return this.$GtsDropdownData.EFltPnrStatus();
      },
      dateTypeOptions() {
         return [
            { name: this.$t("flightSalesReport_transactionDate"), value: 1 },
            { name: this.$t("flightSalesReport_flightDate"), value: 2 },
         ];
      },
      tableColumns() {
         return [
            { label: this.$t("common_orderId"), status: true, identifier: "orderId" },
            { label: this.$t("common_pnrs"), status: true },
            { label: this.$t("common_pnrStatus"), status: true },
            { label: this.$t("common_airlines"), status: true },
            { label: this.$t("common_providerName"), status: true },
            { label: this.$t("common_paxCount"), status: true },
            { label: this.$t("common_nameSurname"), status: true },
            { label: this.$t("common_salesTotal"), status: true },
            { label: this.$t("common_totalRefund"), status: true },
            { label: this.$t("common_currency"), status: true },
            { label: this.$t("common_saleTime"), status: true },
            { label: this.$t("common_cancellationTime"), status: true },
            { label: this.$t("common_departureTime"), status: true },
            { label: this.$t("common_optionExpiryTime"), status: true },
            { label: this.$t("common_userEmail"), status: true },
         ];
      },
      alternativeTableColumns() {
         return [
            { label: this.$t("common_orderId"), status: true, identifier: "orderId" },
            { label: this.$t("common_pnrs"), status: true },
            { label: this.$t("common_pnrStatus"), status: true },
            { label: this.$t("common_airlines"), status: true },
            { label: this.$t("common_providerName"), status: true },
            { label: this.$t("common_eticket"), status: true },
            { label: this.$t("common_eticketStatus"), status: true },
            { label: this.$t("common_nameSurname"), status: true },
            { label: this.$t("common_salesTotal"), status: true },
            { label: this.$t("common_totalRefund"), status: true },
            { label: this.$t("common_currency"), status: true },
            { label: this.$t("common_saleTime"), status: true },
            { label: this.$t("common_cancellationTime"), status: true },
            { label: this.$t("common_departureTime"), status: true },
            { label: this.$t("common_optionExpiryTime"), status: true },
            { label: this.$t("common_userEmail"), status: true },
         ];
      },
      currentTableOptions() {
         return this.tableMode === "default" ? { ...this.tableOptions, columns: this.tableColumns } : { ...this.alternativeTableOptions, columns: this.alternativeTableColumns };
      },
   },
   methods: {
      handleMode(mode) {
         this.tableMode = mode;
      },
      listFlightSalesReport() {
         this.summary = null;
         this.tableOptions.rows = [];
         this.alternativeTableOptions.rows = [];

         this.calculateDateDiff();

         if (this.dateDiff > 365) {
            Popup.info(null, this.$t("Popup_lblFlightSalesReportDateRange"));
         } else {
            this.$store.commit("app/setIsProgressGifActive", true);

            let request = {
               date1: this.searchQuery.date1.value,
               date2: this.searchQuery.date2.value,
               dateType: this.searchQuery.dateType,
               inpSwithPnrEticket: this.searchQuery.inpSwithPnrEticket,
               pnrStatuses: this.searchQuery.pnrStatuses,
               providerIds: this.searchQuery.providerIds,
               marketingAirlineCodes: this.searchQuery.airlineIds,
               showReissues: this.searchQuery.showReissues,
               userIds: this.searchQuery.userIds,
            };

            const includeCancel = request.pnrStatuses.some((status) => {
               return status == 4 || status == 6 || status == 3;
            });

            if (includeCancel) {
               this.tableOptions.rules.autoMerge = ["orderId"];
               this.alternativeTableOptions.rules.autoMerge = ["orderId"];
            }

            reportService.flightSalesReport(request).then((res) => {
               if (res.result.success) {
                  this.$store.commit("app/setIsProgressGifActive", false);
                  this.summary = res.summary;
                  res.items.map((item) => {
                     const rowObj = {
                        orderId: {
                           text: item.orderId,
                           class: `gts-badge smart-table-badge-1`,
                           url: `/order/detail/${item.orderUuid}`,
                        },
                        pnr: {
                           text: item.pnr,
                           class: `pnr-class`,
                        },
                        pnrStatus: {
                           pnrStatus: item.pnrStatus,
                           text: this.$options.filters.EFltPnrStatus(item.pnrStatus),
                           class: `pnr-badge gts-badge EFltPnrStatus-${item.pnrStatus}`,
                        },
                        airlines: {
                           text: item.marketingAirlineCodes,
                           class: `marketing-airline`,
                        },
                        provider: item.provider,
                        paxCount: item.paxCount,
                        passenger: item.passenger,

                        salesTotal: {
                           text: this.$options.filters.price(item.eticketSaleAmount, item.currency),
                           class: "price-display",
                        },
                        refundTotal: {
                           text: this.$options.filters.price(item.eticketReverseAmount, item.currency),
                           class: "price-display",
                        },
                        currency: item.currency,
                        saleDateTime: {
                           text: this.$options.filters.fullDateFormat(item.saleDateTime),
                           class: "",
                        },
                        reverseDateTime: {
                           text: this.$options.filters.fullDateFormat(item.reverseDateTime),
                           class: "",
                        },
                        departureDateTime: {
                           text: this.$options.filters.fullDateFormat(item.departureDateTime) + " " + this.$options.filters.TimeFormat(item.departureDateTime),
                           class: "",
                        },
                        optionDateTime: {
                           text: this.$options.filters.fullDateFormat(item.optionDateTime) + " " + this.$options.filters.TimeFormat(item.optionDateTime),
                           class: "",
                        },
                        saleUserEmail: item.saleUserEmail,
                     };
                     const alternative = {
                        orderId: {
                           text: item.orderId,
                           class: `gts-badge smart-table-badge-1`,
                           url: `/order/detail/${item.orderUuid}`,
                        },
                        pnr: item.pnr,
                        pnrStatus: {
                           pnrStatus: item.pnrStatus,
                           text: this.$options.filters.EFltPnrStatus(item.pnrStatus),
                           class: `pnr-badge gts-badge EFltPnrStatus-${item.pnrStatus}`,
                        },
                        airlines: {
                           text: item.marketingAirlineCodes,
                           class: `marketing-airline`,
                        },
                        provider: item.provider,
                        eticket: {
                           text: `${item.eticket}`,
                           class: "",
                        },
                        eticketStatus: {
                           text: this.$options.filters.EFltPnrStatus(item.eticketStatus),
                           class: `pnr-badge gts-badge EFltPnrStatus-${item.pnrStatus}`,
                        },
                        passenger: item.passenger,
                        salesTotal: {
                           text: this.$options.filters.price(item.eticketSaleAmount, item.currency),
                           class: "price-display",
                        },
                        refundTotal: {
                           text: this.$options.filters.price(item.eticketReverseAmount, item.currency),
                           class: "price-display",
                        },
                        currency: item.currency,
                        saleDateTime: {
                           text: this.$options.filters.fullDateFormat(item.saleDateTime),
                           class: "",
                        },
                        reverseDateTime: {
                           text: this.$options.filters.fullDateFormat(item.reverseDateTime),
                           class: "",
                        },
                        departureDateTime: {
                           text: this.$options.filters.fullDateFormat(item.departureDateTime) + " " + this.$options.filters.TimeFormat(item.departureDateTime),
                           class: "",
                        },
                        optionDateTime: {
                           text: this.$options.filters.fullDateFormat(item.optionDateTime) + " " + this.$options.filters.TimeFormat(item.optionDateTime),
                           class: "",
                        },
                        saleUserEmail: item.saleUserEmail,
                     };

                     this.tableOptions.rows.push(rowObj);

                     this.alternativeTableOptions.rows.push(alternative);
                  });
                  this.handleMode("default");
               }
            });
         }
      },
      calculateDateDiff() {
         const start = moment(this.searchQuery.date1.value, this.$constants.dateFormat);
         const end = moment(this.searchQuery.date2.value, this.$constants.dateFormat);
         this.dateDiff = end.diff(start, "days");
      },
   },
   watch: {
      "searchQuery.dateType"(newVal) {
         const maxDate = newVal === 1 ? this.maxDate : moment().add(1, "year").format(this.$constants.dateFormat);
         this.searchQuery.date1.max = maxDate;
         this.searchQuery.date2.max = maxDate;
      },
      "searchQuery.date1.value"(newDate1) {
         if (moment(newDate1, this.$constants.dateFormat).isAfter(moment(this.searchQuery.date2.value, this.$constants.dateFormat))) {
            this.searchQuery.date2.value = newDate1;
         }
      },
      "searchQuery.date2.value"(newDate2) {
         if (moment(newDate2, this.$constants.dateFormat).isBefore(moment(this.searchQuery.date1.value, this.$constants.dateFormat))) {
            this.searchQuery.date1.value = newDate2;
         }
      },
   },
};
</script>

<style lang="scss">
.sub-page-wrapper {
   .container-fluid {
      @media (min-width: 1200px) {
         width: 90%;
      }

      @media (min-width: 992px) {
         .reportType {
            width: 13%;
         }

         .fromDate {
            width: 10%;
         }

         .toDate {
            width: 10%;
         }
      }

      .sub-page-header {
         font-size: var(--xxlarge);
         font-weight: 600;
         margin-bottom: 2rem;
         @media (max-width: 768px) {
            margin-top: 1rem;
         }
      }

      .sub-page-row-wrapper {
         margin-bottom: 1rem;
      }

      .sub-page-actions-row {
         display: flex;
         justify-content: flex-end;
         margin-top: 1.5rem;
         .sub-pages-actions-wrapper {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .toggle-container {
               margin-right: 1rem;
               .toggle-wrapper {
                  display: flex;
                  label {
                     margin-right: 0.5rem;
                     font-weight: 500;
                  }
               }
            }
         }
      }
   }
   .smart-table-wrapper {
      margin-top: 24px;
   }
}
</style>
